import React from 'react'

const useTaskRightClickMenu = () => {
  const [menuPosition, setMenuPosition] = React.useState({ xPos: 0, yPos: 0 })
  const [showMenu, setShowMenu] = React.useState(false)
  const [showShare, setShowShare] = React.useState(false)

  const handleOpen = e => {
    setMenuPosition({ xPos: e.clientX, yPos: e.clientY })
    setShowMenu(true)
  }

  const handleClose = () => {
    setShowMenu(false)
  }

  return {
    handleOpen,
    handleClose,
    setShowShare,
    menuPosition,
    showMenu,
    showShare
  }
}

export default useTaskRightClickMenu
